import AddSnAdtInfo from "./addSnAdtInfo.container";

export default AddSnAdtInfo;
